import React from "react";

function Icon(props) {
  return (
        <div className={props.className}>
            <svg
                height={props.height}
                style={props.style}
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                strokeLinejoin="round"
                strokeMiterlimit="2"
                clipRule="evenodd"
                viewBox="0 0 225 224"
                style={{verticalAlign: "middle"}}
            >
            <path
                className={props.pathClass ? props.pathClass : "g1-fill"}
                d="M18783.3 3795.53l-70.5-70.52c-3-2.98-7.8-2.98-10.8 0l-12 12c-3 2.98-3 7.81 0 10.79l70.5 70.52-70.5 70.51c-3 2.98-3 7.81 0 10.79l12 12c3 2.98 7.8 2.98 10.8 0l70.5-70.52 70.5 70.52c3 2.98 7.8 2.98 10.8 0l12-12c3-2.98 3-7.81 0-10.79l-70.5-70.51 70.5-70.52c3-2.98 3-7.81 0-10.79l-12-12c-3-2.98-7.8-2.98-10.8 0l-70.5 70.52z"
                transform="translate(-18671.3 -3706.37)"
            ></path>
            <path
                fill="none"
                d="M4994.62 5721.16H5374.557V6147.098H4994.62z"
                transform="matrix(.5902 0 0 .52566 -2947.81 -3007.4)"
            ></path>
            </svg>
        </div>
  );
}

export default Icon;
